var _class;
/*
 *                     NOTICE
 *            COPYRIGHT 2018 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbAsyncActionMenuItem } from "abreact/incubator/ui/component/actionBar/AbAsyncActionMenuItem";
import { AbCustomActionMenuItem } from "abreact/incubator/ui/component/actionBar/AbCustomActionMenuItem";
import { ActionBarMenuMachine } from "abreact/incubator/ui/component/actionBar/ActionBarMenuMachine";
import { ActionMenuUtils } from "abreact/incubator/ui/component/actionBar/ActionMenuUtils";
import { BaseRCmp } from "abreact/incubator/ui/component/BaseRCmp";
import { AbPopup } from "abreact/incubator/ui/popup/AbPopup";
import { PopupPosition } from "abreact/incubator/ui/popup/PopupPosition";
import { PopupUtils } from "abreact/incubator/ui/popup/PopupUtils";
import { AbMenu } from "abreact/menu/AbMenu";
import { AbBusyIndicator, BusyIndicatorSize } from "abreact/progress/AbBusyIndicator";
import { AbPopupManager } from "absdk/commons/ui/popup/AbPopupManager";
import { AB_ITEM_SEPARATOR } from "abweb/collection/AbItemSeparator";
import { ClassUtils } from "abweb/utils/ClassUtils";
import { KeyValue } from "abweb/utils/KeyboardUtils";
import { runInAction } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
/**
 * Implementation of the menu for an action bar
 */
export let AbActionBarMenuRCmp = observer(_class = class AbActionBarMenuRCmp extends BaseRCmp {
  render() {
    return this.props.closedComponent ? this.props.closedComponent : null;
  }
  static async onKeyPress(machine, evt) {
    const e = evt;
    if (e.key === KeyValue.ESCAPE) {
      machine.close();
      return;
    }
    if (await ActionMenuUtils.onKeyPressPerformAction(e, machine)) {
      machine.close();
    }
  }
  static showPopup(machine) {
    const items = async () => {
      return renderItems(machine, machine.menuItems);
    };
    runInAction(() => {
      machine.openHandle = AbPopupManager.show(/*#__PURE__*/React.createElement(AbPopup, {
        dataTestId: "action-bar-menu",
        flushContent: true,
        className: "ab-action-bar-menu-rcmp ab-menu-button-popup",
        position: PopupPosition.FIXED,
        positioner: PopupUtils.createMousePositioner(machine.left - PopupUtils.CURSOR_SIZE, machine.top),
        onClose: () => {
          machine.close();
        },
        overlay: false,
        focus: true,
        closeOnBackgroundClick: true,
        closeOnBackgroundScroll: true
      }, /*#__PURE__*/React.createElement("div", {
        className: "ab-action-bar-menu-wrapper",
        tabIndex: 0,
        onKeyPress: e => this.onKeyPress(machine, e.nativeEvent)
      }, /*#__PURE__*/React.createElement(AbMenu, {
        className: "ab-action-bar-menu-div",
        items: items
      }))));
    });
    return machine.openHandle;
  }
}) || _class;
const renderItems = (machine, menuItems) => {
  if (menuItems == null) {
    return [];
  }
  return menuItems.map((item, index) => {
    let isSubmenu = ClassUtils.isInstanceOf(item, ActionBarMenuMachine);
    const menuItem = isSubmenu ? item.menuItem : item;
    if (menuItem.label || ClassUtils.isInstanceOf(menuItem, AbCustomActionMenuItem)) {
      // If it's got a label or custom rendering, we have a MenuButton to render
      if (menuItem.enabled && ClassUtils.isInstanceOf(menuItem, AbAsyncActionMenuItem) && menuItem.isBusy) {
        return {
          label: /*#__PURE__*/React.createElement(AbBusyIndicator, {
            key: "item" + index,
            className: "ab-action-bar-rcmp-button-busy",
            size: BusyIndicatorSize.TINY
          })
        };
      }
      return {
        disabled: !menuItem.enabled,
        tooltip: ActionMenuUtils.getTooltip(menuItem),
        icon: menuItem.icon,
        label: /*#__PURE__*/React.createElement(React.Fragment, null, menuItem.label, ClassUtils.isInstanceOf(menuItem, AbCustomActionMenuItem) && menuItem.rendering, menuItem.shortcut && /*#__PURE__*/React.createElement("span", {
          className: "ab-action-bar-menu-item-shortcut"
        }, menuItem.shortcut.toString())),
        onClick: e => machine.performAction(0, 0, item, e?.currentTarget),
        dataTestId: menuItem.dataTestId,
        menuItems: isSubmenu ? () => {
          return renderItems(machine, item.menuItems);
        } : undefined
      };
    } else if (index > 0) {
      // No label, so it's a divider
      return AB_ITEM_SEPARATOR;
    } else {
      return null;
    }
  });
};
//# sourceMappingURL=AbActionBarMenuRCmp.js.map
